<template>
  <div class="RiskMannNavbarNotificaciones">
    <div v-if="cargando.registros" class="center_spinner">
      <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <template v-else>
      <p class="fw-normal">
        Estás viendo tus últimas 10 notificaciones. Para acceder al historial completo,
        haz clic en <b>Ver todas</b>.
      </p>
      <div class="d-flex justify-content-between">
        <p class="fw-bold">Nuevas</p>
        <router-link class="text-primary" to="/notificaciones">
          <p data-bs-dismiss="offcanvas" aria-label="Close">
            Ver todas
          </p>
        </router-link>
      </div>
      <div :class="{ 'content': notificaciones.length > 0 }">
        <div :class="{ 'scroll_body': notificaciones.length > 1 }">
          <div v-for="(notificacion, index) in notificaciones" :key="index">
            <Notificacion :class="{ 'mt-3': index !== 0, 'mb-2': notificaciones.length - 1 }"
              :notificacion="notificacion" data-bs-dismiss="offcanvas" aria-label="Close" />
          </div>
        </div>
      </div>
      <div v-if="notificaciones.length === 0" class="col-md-12 mt-3">
        <p class="text-center">No tienes notificaciones</p>
      </div>
      <footer v-if="notificaciones.length > 0" class="footer">
        <a href="javascript:void(0)" class="text-decoration-underline text-primary"
          :class="{ 'cursor_none': cargando.marcarLeidas }" @click="marcarTodosLeidas()">
          <span v-if="cargando.marcarLeidas" class="spinner-border spinner-border-sm me-1" role="status"
            aria-hidden="true"></span>
          <span v-if="cargando.marcarLeidas" class="sr-only">Loading...</span> Marcar todas como leídas
        </a>
      </footer>
    </template>
  </div>
</template>

<script>
import { auth, db, functions } from "@/firebase";
import {
  collection,
  query,
  where,
  getDocs,
  onSnapshot,
  orderBy,
  limit
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import moment from "moment";
import _ from 'lodash';
import Notificacion from "../../Usuario/Notificaciones/Notificacion.vue";
export default {
  name: "RiskMannNavbarNotificaciones",

  components: {
    Notificacion
  },

  data() {
    return {
      notificaciones: [],
      cargando: {
        registros: false,
        marcarLeidas: false
      },
      idUsuario: "",
    };
  },

  async created() {
    const usuario = auth.currentUser;
    if (usuario) {
      const usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
      if (usuarioDB) {
        this.idUsuario = usuarioDB.id;
        await this.obtenerNotificaciones();
      }
    }
  },

  methods: {
    async obtenerNotificaciones() {
      /* OBTENER ULTIMAS ACTUALIZACIONES */
      this.cargando.registros = true;
      this.notificaciones = [];
      const q = query(
        collection(db, "riskmann_notificaciones"),
        where("idUsuario.receptor", "==", this.idUsuario),
        where("esLeida", "==", false),
        orderBy("registro.creacion", "desc"),
        limit(10)
      );
      const querySnapshot = await getDocs(q);
      this.notificaciones = await Promise.all(
        querySnapshot.docs.map((doc) => {
          return {
            id: doc.id,
            tipo: doc.data().tipo ? doc.data().tipo : doc.data().titulo === "Recordatorio de Seguridad Vial" ? "Recordatorio" : "Informativo",
            prioridad: doc.data().prioridad ? doc.data().prioridad : doc.data().titulo === "Recordatorio de Seguridad Vial" ? "Media" : "Baja",
            titulo: doc.data().titulo,
            contenido: doc.data().contenido,
            icono: doc.data().icono,
            url: doc.data().url,
            registro: {
              leida: moment(doc.data({ serverTimestamps: "estimate" }).registro.leida.toDate()).format("DD/MM/YYYY hh:mm A"),
              creacion: moment(doc.data({ serverTimestamps: "estimate" }).registro.creacion.toDate()).format("DD/MM/YYYY hh:mm A"),
              actualizacion: moment(doc.data({ serverTimestamps: "estimate" }).registro.actualizacion.toDate()).format("DD/MM/YYYY hh:mm A")
            },
          }
        })
      );
      let set = new Set(this.notificaciones.map(JSON.stringify));
      this.notificaciones = Array.from(set).map(JSON.parse);

      /* COPIAR CONSULTA PARA COMPARAR CAMBIOS */
      const copia = await Promise.all(
        querySnapshot.docs.map((doc) => {
          return { ...doc.data() }
        })
      );
      this.cargando.registros = false;

      /* DETECTAR ULTIMOS CAMBIOS */
      let cambios = [];
      onSnapshot(q, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === 'added' || change.type === 'modified') {
            cambios.push(change.doc.data());
          } else if (change.type === "removed") {
            for (let index = 0; index < this.notificaciones.length; index++) {
              if (change.doc.id == this.notificaciones[index].id) {
                this.notificaciones.splice(index, 1);
              }
            }
          }
        });
        if (!_.isMatch([copia], [cambios]) && _.isMatch([cambios], [copia])) {
          setTimeout(() => {
            this.obtenerNotificaciones();
          }, 2000);
        }
      });
    },

    async marcarTodosLeidas() {
      this.cargando.marcarLeidas = true;
      try {
        const marcarLeidas = httpsCallable(functions, 'marcarNotificacionesLeidas');
        const { data } = await marcarLeidas();
        if (data && data.updated > 0) {
          this.$store.state.alerta("success", "¡Todas tus notificaciones han sido marcadas como leídas!");
        } else {
          this.$store.state.alerta("info", "No tienes notificaciones pendientes por leer.");
        }
      } catch (error) {
        console.error('Error al marcar todas como leídas:', error);
        this.$store.state.alerta("error", "Hubo un problema al actualizar tus notificaciones.");
      } finally {
        this.cargando.marcarLeidas = false;
      }
    },
  },
};
</script>

<style scoped>
.center_spinner {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
  left: 50%;
  top: 50%;
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.scroll_body {
  overflow-y: scroll;
  overflow-x: hidden;
  flex-grow: 1;
  padding-right: 10px;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 280px;
}

.footer {
  position: sticky;
  bottom: 1;
  z-index: 1;
  margin-top: 10px;
}

.cursor_none {
  pointer-events: none;
}

@media screen and (max-width: 740px) {
  .content {
    height: 255px;
  }
}

@media screen and (max-width: 400px) {
  .content {
    height: 235px;
  }
}

@media screen and (max-width: 310px) {
  .content {
    height: 215px;
  }
}
</style>
